(function () {
  var batchData = window.BatchData;
  if (!batchData || !Object.keys(batchData).length) return;

  var LOT_INPUT_NAME = "properties[Lot]";
  var LOT_INPUT_SELECTOR = 'input[name="properties[Lot]"][data-batch-lot-input]';
  var CART_ADD_FORM_SELECTOR = 'form[action*="/cart/add"]';
  var syncTimer = null;

  function getActiveLot(variantId) {
    if (!variantId) return null;
    return batchData[String(variantId)] || null;
  }

  function getVariantIdFromForm(form) {
    var field =
      form.querySelector('[name="id"]:not([disabled])') ||
      form.querySelector('[name="id"]') ||
      form.querySelector('[name="variant_id"]');

    return field ? field.value : null;
  }

  function syncLotInput(form, variantId) {
    if (!form || !form.matches || !form.matches(CART_ADD_FORM_SELECTOR)) return;

    var lot = getActiveLot(variantId || getVariantIdFromForm(form));
    var input = form.querySelector(LOT_INPUT_SELECTOR);

    if (!lot) {
      if (input) input.remove();
      return;
    }

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = LOT_INPUT_NAME;
      input.setAttribute("data-batch-lot-input", "");
      form.appendChild(input);
    }

    input.value = lot;
  }

  function syncAllForms() {
    document.querySelectorAll(CART_ADD_FORM_SELECTOR).forEach(function (form) {
      syncLotInput(form);
    });
  }

  function scheduleSyncAll() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncAllForms();
    }, 50);
  }

  function syncChangedForm(target) {
    if (!target || !target.closest) return;
    var form = target.closest(CART_ADD_FORM_SELECTOR);
    if (form) syncLotInput(form);
  }

  function syncTriggeredForm(target) {
    if (!target || !target.closest) return;

    var form = target.closest(CART_ADD_FORM_SELECTOR);
    var trigger = target.closest('[name="add"], button[type="submit"], [data-add-to-cart], .product-form__submit');

    if (!form && trigger?.form?.matches?.(CART_ADD_FORM_SELECTOR)) {
      form = trigger.form;
    }

    if (form) syncLotInput(form);
  }

  function init() {
    syncAllForms();

    document.addEventListener(
      "submit",
      function (event) {
        if (event.target?.matches?.(CART_ADD_FORM_SELECTOR)) {
          syncLotInput(event.target);
        }
      },
      true
    );

    document.addEventListener(
      "change",
      function (event) {
        var target = event.target;
        if (target?.matches?.('[name="id"], [name="variant_id"]')) {
          syncChangedForm(target);
        }
      },
      true
    );

    ["pointerdown", "click"].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function (event) {
          syncTriggeredForm(event.target);
        },
        true
      );
    });

    document.addEventListener("variant:changed", syncAllForms);

    new MutationObserver(scheduleSyncAll).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
